import { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

// Premium image carousel for winner cards. Prefers admin-uploaded handover
// photos and lets users swipe/scroll through multiple images.
export default function WinnerPhotoCarousel({ photos = [], alt = '', className = '', imgClassName = '' }) {
  const imgs = (photos || []).filter(Boolean);
  const [idx, setIdx] = useState(0);

  if (imgs.length === 0) {
    return <div className={`bg-rolex-green/10 ${className}`} />;
  }

  const go = (e, d) => {
    e.preventDefault();
    e.stopPropagation();
    setIdx((p) => (p + d + imgs.length) % imgs.length);
  };

  return (
    <div className={className} data-testid="winner-photo-carousel">
      {imgs.map((src, i) => (
        <img
          key={i}
          src={src}
          alt={alt}
          className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-500 ${i === idx ? 'opacity-100' : 'opacity-0'} ${imgClassName}`}
        />
      ))}
      {imgs.length > 1 && (
        <>
          <button
            type="button"
            onClick={(e) => go(e, -1)}
            className="absolute left-2 top-1/2 -translate-y-1/2 z-20 w-8 h-8 rounded-full bg-rolex-green/70 text-cream flex items-center justify-center backdrop-blur-sm opacity-80 hover:opacity-100 hover:bg-rolex-green transition-all"
            data-testid="winner-photo-prev"
            aria-label="Previous photo"
          >
            <ChevronLeft className="w-4 h-4" />
          </button>
          <button
            type="button"
            onClick={(e) => go(e, 1)}
            className="absolute right-2 top-1/2 -translate-y-1/2 z-20 w-8 h-8 rounded-full bg-rolex-green/70 text-cream flex items-center justify-center backdrop-blur-sm opacity-80 hover:opacity-100 hover:bg-rolex-green transition-all"
            data-testid="winner-photo-next"
            aria-label="Next photo"
          >
            <ChevronRight className="w-4 h-4" />
          </button>
          <div className="absolute bottom-2 left-1/2 -translate-x-1/2 z-20 flex gap-1.5">
            {imgs.map((_, i) => (
              <button
                key={i}
                type="button"
                onClick={(e) => { e.preventDefault(); e.stopPropagation(); setIdx(i); }}
                className={`h-1.5 rounded-full transition-all ${i === idx ? 'w-5 bg-gold' : 'w-1.5 bg-cream/60 hover:bg-cream'}`}
                aria-label={`Go to photo ${i + 1}`}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
}
